module.exports = __webpack_public_path__ + "static/media/DSC04196.73a5aa23.JPG";